<template>
  <div class="c-app">
    <TheSidebar  />
    <div id="cwrapper" class="c-wrapper">
      
      <TheHeader v-if="!isHmsFlow" />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <!-- <span>{{$t('langTest')}}</span> mode="out-in" -->
<!-- <transition name="page" > </transition> -->
              <router-view></router-view>

          </CContainer>
        </main>
      </div>
      <!-- <TheFooter/> -->
    </div>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import {Event} from "../main.js"
import BaseConfiguration from "../config/base";
import router, { navigate, goBack } from "../router/index";
import { PATHNAME } from '../util/constants';
import { isHmsFlow} from "./../util/util";

//import { create } from 'domain'




export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    
  },
   data: () => ({
     isHmsFlow: BaseConfiguration.isHmsFlow,
  }),
  methods:{
    toCheckForHmsFlow(pIsHmsFlow){
      this.isHmsFlow = pIsHmsFlow;
      BaseConfiguration.isHmsFlow=pIsHmsFlow
    }
  },
  mounted() {
    if(isHmsFlow(this.$router.currentRoute.path)){
      this.toCheckForHmsFlow(true);
    }
            Event.$on("isHmsFlow",(pIsHmsFlow) => {
                this.toCheckForHmsFlow(pIsHmsFlow);
            });

           
        },
  
}
</script>

<style>
.desc{
  padding-left: 10px
}
.removewrap{
  white-space: nowrap
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.removewrap{
  white-space: nowrap;
}
</style>
